import React from 'react'
import { useSelector } from 'react-redux'
import { Button, CircularProgress, Typography } from '@material-ui/core'
import { SectionLayoutDialog } from 'shared'

import { useStyles } from './DeleteConfirmDialog.style'

const DeleteConfirmDialog = ({ open, onClose, onConfirm }) => {
  const classes = useStyles()

  const { deletePending } = useSelector((state) => state.events)

  return (
    <SectionLayoutDialog
      title='Eliminar evento'
      open={open}
      onClose={onClose}
      className={classes.dialog}>
      <Typography variant='h6' align='center' className={classes.question}>
        ¿Estás seguro que deseas eliminar este evento?
      </Typography>
      <div className={classes.buttonsContainer}>
        <Button
          onClick={onClose}
          className={classes.button}
          color='primary'
          variant='contained'
          disabled={deletePending}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          className={classes.button}
          variant='outlined'
          color='primary'
          disabled={deletePending}
          endIcon={deletePending ? <CircularProgress size={20} color='primary' /> : undefined}>
          Eliminar
        </Button>
      </div>
    </SectionLayoutDialog>
  )
}

export default DeleteConfirmDialog
